
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/get-subscription-link",
      function () {
        return require("private-next-pages/get-subscription-link.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/get-subscription-link"])
      });
    }
  